import Vue from 'vue'

import VueSweetalert2 from 'vue-sweetalert2';
import App from './App.vue'

import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'

import debounce from 'lodash/debounce';


import VModal from 'vue-js-modal';

//Define app                 
window.context = "hdtool";


import VueCookies from 'vue-cookies'
import 'sweetalert2/dist/sweetalert2.min.css';

import 'datatables.net'

import 'datatables.net-responsive'

import 'datatables.net-fixedheader'

import './assets/datatables/dataTables.dataTables.css'
import './assets/datatables/responsive.dataTables.css'
import './assets/datatables/fixedHeader.dataTables.css'

import InactivityPlugin from './plugins/inactivity'


import router from './router'
import vuetify from './plugins/vuetify'

import '@mdi/font/css/materialdesignicons.css'

import api from './utils/api';

Vue.$api = api

Object.defineProperty(Vue.prototype, '$api', {
  get() {
    return api
  }
})
Vue.prototype.$withBase = relativePath => `${process.env.BASE_URL}${relativePath}`

var loggedIn = window.$cookies.get("token");

// 🔌 Usa il plugin (timeout = 30 minuti)
Vue.use(InactivityPlugin, { timeout: 30 * 60 * 1000 })


Vue.use(VueCookies);
Vue.use(debounce);

Vue.use(VueSweetalert2);
Vue.use(VueAxios, axios);
Vue.use(VueRouter)

Vue.use(VModal, {
  dialog: true
});



if (loggedIn) {
  Vue.prototype.userLogged = true;

}
export const bus = new Vue();

window.App = new Vue({
  router,
  vuetify,

  render: h => h(App)
}).$mount('#app')


if (loggedIn == null) {

  if (!document.location.hash.toString().includes("reservate")) {

    router.push({ path: '/' }).catch(() => { });

  }


}